module.exports = __webpack_public_path__ + "img/case2.fdea0d50.png";